import {
  ChangeDetectionStrategy,
  Component,
  input,
  viewChild,
} from '@angular/core';
import { ModalComponent } from '@appkit4/angular-components/modal';

@Component({
  standalone: false,
  selector: 'gstar-field-overflow-modal',
  templateUrl: './field-overflow-modal.component.html',
  styleUrl: './field-overflow-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldOverflowModalComponent {
  modalTitle = input.required<string>();
  modalContent = input.required<string>();
  isHtmlContent = input.required<boolean>();

  modal = viewChild<ModalComponent>('modal');

  showModal(): void {
    const modalInstance = this.modal();
    if (modalInstance) {
      modalInstance.showModal(this.modalTitle());
      modalInstance.title = this.modalTitle();
    }
  }
}
